<template lang="pug">
  div
    .breakText.labelDiv
      el-col.inputDiv(:span="12")
        app-display(
          label="Logradouro:",
          :content="endereco.logradouro"
        )
        app-display(
          label="Número:",
          :content="getNumero()"
        )
        app-display(
          label="Bairro:",
          :content="endereco.bairro",
          :marginTopBottom="endereco.complemento !== '' && !!endereco.complemento"
        )
        app-display(
          label="Complemento:",
          :content="getValue(endereco.complemento)"
        )
      el-col.inputDiv(:span="12")
        app-display(
          label="CEP:",
          :content="endereco.cep"
        )
        app-display(
          label="UF:",
          :content="getEstado(endereco.municipio)"
        )
        app-display(
          label="Município:",
          :content="endereco.municipio ? endereco.municipio.nome : '-'"
        )

</template>

<script>
import AppDisplay from '@/components/AppDisplay'
import estados from '@/constants/estados'

export default {
  props: {
    endereco: {
      type: Object,
      required: true
    }
  },
  components: {
    AppDisplay
  },
  methods: {
    getEstado (municipio) {
      const estado = estados.filter(item => item.codigo === municipio.codigoEstado)[0]
      return estado ? estado.nome : '-'
    },
    getNumero () {
      return this.endereco.semNumero ? 'S/N' : this.endereco.numero
    },
    getValue (params) {
      return params || '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.breakText {
  word-break: break-all;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/common/InformacoesEndereco.vue